export default __webpack_public_path__ + "static/media/growth.2802e168.svg";